import { render, staticRenderFns } from "./datatable.vue?vue&type=template&id=01cb5b13&"
import script from "./datatable.vue?vue&type=script&scoped=true&lang=js&"
export * from "./datatable.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./datatable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports